<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="延期丢失"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="360px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
        <el-form-item label="原结束时间：" label-width="84px"
            class="label-with-five-word">
          <el-input
            size="mini"
            v-model.trim="endTime"
            disabled
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="结束时间：" class="mb0" prop="endTime">
          <el-date-picker
            v-model="form.endTime"
            align="right"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            size="mini"
            prefix-icon=" "
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button
        class="plr28"
        type="primary"
        size="mini"
        :loading="loadBtn"
        @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { finishContract } from "@/api/ContractManagement";
export default {
  data() {
    return {
      form: {
        endTime: ""
      },
      rules: {
        endTime: [
          {
            required: true,
            message: "请选择延合同结束时间",
            trigger: "change",
          },
        ],
      },
      loadBtn: false
    };
  },
  props: {
    endTime: {
      required: true
    },
    contractId: {
      required: true
    }
  },
  created() {
    this.pickerOptions = {
      disabledDate: time => {
        if (this.endTime) {
          const endTime = new Date(this.endTime).getTime()
          return time.getTime() < endTime
        } else {
          return false
        }
      }
    }
  },
  methods: {
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loadBtn = true;
          let params = {
            contractId: this.contractId,
            endTime: this.form.endTime
          }
          const res = await finishContract(params);
          if (res.code === 200) {
            this.$message.success("成功");
            this.$emit("confirm");
          }
          this.loadBtn = false;
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/ContractManagement/components/FinishContract.vue